module.exports = __webpack_public_path__ + "media/images/icons/x-aac37a3e7f28df68197577b36a647dbd.svg";